
import { useEffect, useState } from "react";
import { ROUTES } from "../Routes/routes";
import GenericLayout from "./GenericLayout";

export default function DentistLayout() {
  const [menu, setMenu] = useState<any[]>([]);
  const [clinicApproved, setClinicApproved] = useState(false);

  const buildMenu = (approved: boolean) => [
    {
      key: ROUTES.DENTIST.DENTIST_DASHBOARD,
      label: "Orders",
      icon: "bi bi-house-fill",
      iconImage: "../flaticon/Home.png",
      disabled: !approved,
    },
    {
      key: ROUTES.DENTIST.ScheduledOrders,
      label: "Scheduled Orders",
      icon: "bi-calendar2-check-fill",
      iconImage: "",
      disabled: !approved,
    },
     {
      key: ROUTES.DENTIST.ScheduleOrdersList,
      label: "Scheduled OrdersList",
      icon: "bi-calendar2-check-fill",
      iconImage: "",
      disabled: !approved,
    },
    
    {
      key: ROUTES.DENTIST.DENTIST_DRAFT_LIST,
      label: "Drafts",
      icon: "bi bi-folder-fill",
      iconImage: "",
      disabled: !approved,
    },
      {
      key: ROUTES.DENTIST.DENTIST_CancelOrder,
       label: "Cancelled Orders",
      icon: "bi-x-octagon-fill",
      iconImage: "",
      disabled: !approved,
    },
      {
      key: ROUTES.DENTIST.CompleteOrder,
      label: "Complete Order",
      icon: "bi-patch-check-fill",
      iconImage: "",
      disabled: !approved,
    },
     {
      key: ROUTES.DENTIST.PaymentRetryPage,
      label: "Payment Retry",
      icon: "bi bi-folder-fill",
      iconImage: "",
      disabled: !approved,
    },
  
    {
      key: ROUTES.DENTIST.DentistContactSupport,
      label: "Contact Support",
      icon: "bi-headset",
      iconImage: ''
    },
  
    {
      key: ROUTES.DENTIST.DENTIST_Report,
      label: "Report",
      icon: "bi-file-earmark-text-fill",
      iconImage: "",
      disabled: !approved,
    },
    {
      key: ROUTES.DENTIST.RaiseTicket,
      label: "Raise Ticket",
      icon: "bi-tags-fill",
      iconImage: "",
      disabled: !approved,
    }

  ];

  const menuGroups = [
    {
      title: "Settings",
      icon: "bi-collection-fill",
      items: [
        {
          key: ROUTES.DENTIST.CLINIC_DETAILS,
          label: "Add Clinic",
          icon: "bi bi-hospital-fill",
          iconImage: "",
        },
      ]
    }
  ];

  // 1️⃣ Initial load
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    // const approved =
    //   user?.clinicDetails?.some((c: any) => c.isApprove === true) || false;
    const approved =
      user?.clinicDetails?.some(
        (c: any) => c.isApprove === true && c.isActive === true
      ) || false;
    setClinicApproved(approved);
    setMenu(buildMenu(approved));
  }, []);

  // 2️⃣ Listen for approval (NO refresh)
  useEffect(() => {
    const onClinicApproved = () => {
      const user = JSON.parse(sessionStorage.getItem("user") || "{}");
      // const approved =
      //   user?.clinicDetails?.some((c: any) => c.isApprove === true) || false;

      const approved =
        user?.clinicDetails?.some(
          (c: any) => c.isApprove === true && c.isActive === true
        ) || false;
      setClinicApproved(approved);
      setMenu(buildMenu(approved)); // 🔥 sidebar updates instantly
    };

    window.addEventListener("clinicApproved", onClinicApproved);

    return () =>
      window.removeEventListener("clinicApproved", onClinicApproved);
  }, []);

  return (
    <GenericLayout
      menu={menu}
      menuGroups={menuGroups}
      titleLabel="Dentist"
      profileRoute={ROUTES.DENTIST.DENTIST_PROFILE}
      showNotifications
      apiNotificationUrl={`${process.env.REACT_APP_API_BASE_URL}/ClinicDetails/GetClinicNotifications`}
    />
  );
}
